import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { ActivatedRoute } from '@angular/router';
import { EventService } from '../../../services/event.service';
import { FreeRegistrationComponent } from '../free-registration/free-registration.component';
import { RegistrationClosedComponent } from '../registration-closed/registration-closed.component';
import { RegistrationComponent } from '../registration/registration.component';


@Component({
  selector: 'app-registration-wrapper',
  imports: [
    CommonModule, 
    RegistrationClosedComponent, 
    RegistrationComponent, 
    FreeRegistrationComponent,
    MatStepperModule],
  templateUrl: 'registration-wrapper.component.html',
  styleUrl: 'registration-wrapper.component.scss',
  providers: [
    { provide: STEPPER_GLOBAL_OPTIONS, useValue: { showError: true } }
  ]
})
export class RegistrationWrapperComponent implements OnInit {
  @ViewChild('stepper') stepper!: MatStepper;
  private readonly route = inject(ActivatedRoute);
  event = this.route.parent!.snapshot.data['event'];  
  
  ngOnInit(): void {
    console.debug('RegistrationWrapperComponent initialized with event:', this.event);
  }
}
